var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.headerState)?_c('header-menu',{attrs:{"logo":_vm.logoUrl}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }